import cx from 'classnames'
import { useButton } from '@react-aria/button'
import { mergeProps } from '@react-aria/utils'
import { forwardRef, PointerEvent } from 'react'
import { useObjectRef } from 'utils/useObjectRef'
import { useNavItemContext } from '../NavItemContext'
import Styles from './Control.module.scss'

import { ControlProps } from './Types'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { useIsSystemRedesign } from 'hooks/useIsSystemRedesign'

const Control = forwardRef<HTMLButtonElement, ControlProps>(({ onPress, icon: Icon, ...rest }, fRef) => {
  const isSystemRedesignEnabled = useIsSystemRedesign()
  const ref = useObjectRef<HTMLButtonElement>(fRef)
  const { buttonProps } = useButton({ onPress }, ref)
  const navItemContext = useNavItemContext()
  const { isMobileMd } = useResponsiveDesign()

  const iconSize = isSystemRedesignEnabled ? 15 : 16

  return (
    <button
      className={cx(Styles.control, { [Styles.hidden]: !navItemContext.isHovered && !isMobileMd })}
      {...mergeProps(
        {
          onClick: (e: PointerEvent<HTMLElement>) => {
            e.stopPropagation()
            e.preventDefault()
            navItemContext.onPointerLeave?.(e)
          },
        },
        buttonProps,
      )}
      ref={ref}
      {...rest}
    >
      <Icon size={iconSize} />
    </button>
  )
})

export { Control }
